import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectExamByClassRoutine {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectExamByClassRoutine = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectExamByClassRoutine) => {
  const itemList = useStoreState((state) => state.exam.examListByClassAndClassIdroutine)

  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.examId === id);
      onChange(value.examId);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Exam"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.examId} value={type.examId}>
            {type.examName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Exam</Option>
      )}
    </Select>
  );
};
